<div
  class="login"
  [ngClass]="[brand === 'VIVUS' ? 'vivus-style' : '', isMobile ? 'mobile' : '']"
>
  <div class="container">
    <div class="row flex-column align-items-center mt-lg-2 mb-lg-5">
      <div class="col-md-4">
        <app-vpn-banner/>
      </div>
      <div class="col-md-12">
        <app-title>Входите, будьте как дома</app-title>
      </div>
      <div class="col-md-4 col-xs-12 col-sm-8 container-landscape">
        <form
          [formGroup]="authorizationForm"
          (submit)="sendWithCaptcha($event, authorizationForm)"
        >
          <div class="login-inputs">
            <app-phone-field
              [formGroup]="authorizationForm"
              fieldName="phone"

              placeholder="Ваш телефон"
              (focusout)="clearError()"
            >
            </app-phone-field>
            <app-password-field
              [formGroup]="authorizationForm"
              fieldName="password"
              placeholder="Пароль от личного кабинета"

              (focusout)="deleteSpaces('password', authorizationForm)"
            >
            </app-password-field>
          </div>

          <p-messages severity="error" *ngIf="showError">
            <ng-template pTemplate="">
              <span *ngIf="!deactivate">
                Неверный номер или пароль. Убедитесь, что номер телефона введен
                без цифры 8 в начале.
              </span>
              <span *ngIf="deactivate">
                Ваш аккаунт на дополнительной проверке. Для уточнения деталей, свяжитесь с нами.
                <br/>
                <p *ngIf="brand === 'VIVUS'; else deactiveSmsf">
                  Горячая линия: 8-800-505-6493 Электронная почта: info@vivus.ru.
                </p>
                <ng-template #deactiveSmsf>
                  <p>
                    Горячая линия: 8-800-333-2757 Электронная почта: info@smsfinance.ru
                  </p>
                </ng-template>
              </span>
            </ng-template>
          </p-messages>

          <div class="login-buttons">
            <p-button
              type="submit"
              label="Войти"
              [loading]="disabled"
            ></p-button>
            <button
              pButton
              pRipple
              class="p-button-text"
              (click)="redirectToRecovery()"
              label="Забыли пароль ?"
            ></button>
          </div>
        </form>
      </div>
      <div class="col-md-6 col-sm-12 mt-4 mb-4">
        <div class="new-user">
          <app-title>Впервые у нас?</app-title>
          <span
          >Чтобы войти в личный кабинет, пройдите простую регистрацию, и Вы
            сможете пользоваться нашими услугами вместе с тысячами наших
            клиентов.</span
          >
        </div>
      </div>
      <div class="col-md-6 col-sm-12 mb-5 d-flex justify-content-center">
        <button pButton class="button" (click)="registration()">
          Зарегистрироваться
        </button>
      </div>
    </div>
  </div>
</div>
